import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import LangEnum from '../../lang/LangEnum';
import { EmphasisCatalog } from '../../modules/catalogs/catalog.types';
import { useTranslation } from '../../modules/translation/TranslationContext';
import { EMPTY_MEDIAS_PATH } from '../../utils/images.constants';
import { ShowroomTestIds } from '../../utils/testIds/Showroom.testIds';
import useWidth from '../Hooks/useWidth';
import EmptyPlaceholder from '../Table/EmptyPlaceholder';
import EmphasisCatalogCardGroup from './EmphasisCatalogCardGroup';
import GroupedCarousel, {
  CAROUSEL_GRID_SIZES,
  getItemsSizeBySelectedBreakpoint,
} from './GroupedCarousel';
import Section, { SectionProps } from './Section';

export type EmphasisCatalogSectionProps = {
  sectionProps: Partial<SectionProps>;
  emphasisCatalogs: EmphasisCatalog[];
  enableLink: boolean;
};

const EmphasisCatalogSection = ({
  sectionProps,
  emphasisCatalogs,
  enableLink,
}: EmphasisCatalogSectionProps) => {
  const { activeBreakpoint } = useWidth();
  const cardsLength: number = getItemsSizeBySelectedBreakpoint(
    CAROUSEL_GRID_SIZES,
    activeBreakpoint,
  );
  const { translate } = useTranslation();

  const renderMediaGroupStep = (items: EmphasisCatalog[]) => (
    <EmphasisCatalogCardGroup enableLink={enableLink} items={items} />
  );

  return (
    <Section {...sectionProps}>
      <Box
        test-id={ShowroomTestIds.FEATURED_CATALOG_DETAILS}
        sx={{
          pb: { xs: 3, sm: 2 },
        }}
      >
        <Typography variant="h5" color="text.primary">
          {translate(LangEnum.SHOWROOM_CATALOGS)}
        </Typography>
      </Box>
      {emphasisCatalogs?.length > 0 ? (
        <GroupedCarousel<EmphasisCatalog>
          groupSize={cardsLength}
          items={emphasisCatalogs}
          renderItemGroup={renderMediaGroupStep}
        />
      ) : (
        <EmptyPlaceholder src={EMPTY_MEDIAS_PATH} message="Nenhum catálogo em destaque ainda!" />
      )}
    </Section>
  );
};

export default EmphasisCatalogSection;
